<template>
    <div class="welcome-landing-root grade-11-curriculum-page min-h-screen bg-background">
        <welcome-navbar />
        <grade-11-curriculum-landing />
        <welcome-footer />
    </div>
</template>

<script>
import WelcomeNavbar from '@/components/welcome/landing/WelcomeNavbar.vue';
import WelcomeFooter from '@/components/welcome/landing/WelcomeFooter.vue';
import Grade11CurriculumLanding from '@/components/welcome/landing/grade11-curriculum/Grade11CurriculumLanding.vue';

export default {
    name: 'Grade11Curriculum',
    components: {
        WelcomeNavbar,
        WelcomeFooter,
        Grade11CurriculumLanding,
    },
};
</script>

<style src="@/scss/welcome-landing.css"></style>
<style src="@/scss/grade-11-curriculum.css"></style>
<style src="@/seo/seo.css"></style>
